import {FC, memo} from 'react';

import {Avatar, Stack, Typography} from '@mui/material';
import GroupsIcon from '@mui/icons-material/Groups';

import {IAssignTo} from '../../../../store/service-requests/atoms';
import {IUserAccount} from '../../../../shared/types/user-account.types';
import {IWorkerSelectOption} from '../../../../api/strategies/searchWorkersStrategy';

interface IWorkerRow {
  worker: IWorkerSelectOption<IUserAccount>;
  choose: (assignTo: IAssignTo) => void;
  isChosen: boolean;
}

const rowStyle = {
  padding: '7px 5px',
  justifyContent: 'space-between',
  borderBottom: '1px solid #e0e0e0',
};

const WorkerRowBase: FC<IWorkerRow> = ({worker, choose, isChosen}) => {
  return (
    <Stack
      onClick={() => choose({id: worker.value.uid, type: 'USER'})}
      sx={{
        ...rowStyle,
        cursor: 'pointer',
        backgroundColor: isChosen ? '#ffbdad' : '#fff',
        '&:hover': {
          backgroundColor: isChosen ? '#ffb29f' : '#f3f3f3',
        },
      }}
      direction="row"
    >
      <Stack direction="row" spacing={1} sx={{alignItems: 'center'}}>
        {worker.photo ? (
          <Avatar sx={{width: 30, height: 30}} src={worker.photo || ''} />
        ) : (
          <GroupsIcon color="primary" sx={{width: 28, height: 28}} />
        )}
        <Typography variant="subtitle2">{worker.label}</Typography>
      </Stack>
    </Stack>
  );
};

export const WorkerRow = memo(WorkerRowBase);
